import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const SERIES = [
  { key: "bookings", label: "Førespurnader", colour: "hsl(var(--sol))" },
  { key: "messages", label: "Meldingar", colour: "hsl(var(--brand))" },
  { key: "tickets", label: "Billettar", colour: "hsl(var(--room-4))" },
];

const Tip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-xl border border-border bg-popover px-3 py-2 text-[12.5px] shadow-lift">
      <p className="t-mono-sm mb-1 text-muted-foreground">Veke {String(label).replace("V", "")}</p>
      {payload.map((p) => <p key={p.dataKey} className="flex items-center gap-2"><span className="h-2 w-2 rounded-full" style={{ background: p.stroke }} />{SERIES.find((s) => s.key === p.dataKey)?.label}: <span className="font-medium tabular">{p.value}</span></p>)}
    </div>
  );
};

/** Soft area chart of the last 8 weeks – førespurnader, meldingar og billettar. */
export const ActivityChart = ({ series, height = 200 }) => {
  const data = (series?.weeks || []).map((w, i) => ({ week: w, bookings: series.bookings?.[i] ?? 0, messages: series.messages?.[i] ?? 0, tickets: series.tickets?.[i] ?? 0 }));
  const empty = data.every((d) => !d.bookings && !d.messages && !d.tickets);
  return (
    <div className="min-w-0" data-testid="dashboard-activity-chart">
      <div className="relative w-full min-w-0 overflow-hidden" style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 10, right: 8, left: -22, bottom: 0 }}>
          <defs>
            {SERIES.map((s) => <linearGradient key={s.key} id={`grad-${s.key}`} x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor={s.colour} stopOpacity={0.28} /><stop offset="100%" stopColor={s.colour} stopOpacity={0} /></linearGradient>)}
          </defs>
          <CartesianGrid vertical={false} stroke="hsl(var(--border))" strokeDasharray="3 3" />
          <XAxis dataKey="week" tickLine={false} axisLine={false} tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 11 }} dy={6} />
          <YAxis allowDecimals={false} tickLine={false} axisLine={false} tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 11 }} width={40} />
          <Tooltip content={<Tip />} cursor={{ stroke: "hsl(var(--foreground) / 0.2)" }} />
          {SERIES.map((s) => <Area key={s.key} type="monotone" dataKey={s.key} stroke={s.colour} strokeWidth={2} fill={`url(#grad-${s.key})`} dot={false} activeDot={{ r: 4, strokeWidth: 0 }} isAnimationActive animationDuration={700} />)}
        </AreaChart>
      </ResponsiveContainer>
      {empty && <p className="pointer-events-none absolute inset-0 flex items-center justify-center text-sm text-muted-foreground">Ingen aktivitet dei siste 8 vekene enno.</p>}
      </div>
      <ul className="mt-2 flex flex-wrap gap-x-4 gap-y-1 px-1 text-[12px] text-muted-foreground">{SERIES.map((s) => <li key={s.key} className="inline-flex items-center gap-1.5"><span className="h-2 w-2 rounded-full" style={{ background: s.colour }} />{s.label}</li>)}</ul>
    </div>
  );
};
